import log from './logger.js';

import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import {Style, Stroke, Fill} from 'ol/style';

let optAbschnittLayer;
let optionsOverlay;

function setOptionsOverlay(overlay) {
    optionsOverlay = overlay;
}
function getHost() {
    if (document.location.host.indexOf("wandern-andreasberge") > -1) {
        return "https://gis.wandern-andreasberge.de/";
    }
    return "http://localhost:8082/";
}
async function getJunctionInfos(junctionID) {
    const url = getHost() + "junction/" + junctionID;
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        
        const result = await response.json();
        return result;
    } catch (error) {
        log.error(error.message);
    }
    return undefined;
}

async function postRoute(junction, selectedWanderabschnitte) {
    const IDs = [];
    selectedWanderabschnitte.forEach((verbindung => {
        IDs.push(verbindung.wanderabschnitt);
    }));
    const url = getHost() + "route";
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'text/plain',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                startJunction: junction,
                wanderabschnitte: IDs
            })
        });
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }

        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = 'andreasberge-route.gpx';
        link.click();
        URL.revokeObjectURL(objectUrl);
    } catch (error) {
        log.error(error.message);
    }
    return undefined;
}

async function getWanderpunkte() {
    const url = "wanderpunkte/wanderpunkte.geojson";
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }
        
        const result = await response.json();
        return result;
    } catch (error) {
        log.error(error.message);
    }
    return undefined;
}
function showPossibilities(junctionId, options) {
    const routeOptions = document.getElementById('routeOptions');
    routeOptions.innerHTML = "";

    const optionsTable = document.createElement('table');
    const tableHeadRow = document.createElement('tr');
    let tableHead = document.createElement('th');
    let text = document.createTextNode('Länge');
    tableHead.appendChild(text);
    tableHeadRow.appendChild(tableHead);

    tableHead = document.createElement('th');
    text = document.createTextNode('Anstieg');
    tableHead.appendChild(text);
    tableHeadRow.appendChild(tableHead);

    tableHead = document.createElement('th');
    text = document.createTextNode('Abstieg');
    tableHead.appendChild(text);
    tableHeadRow.appendChild(tableHead);

    optionsTable.appendChild(tableHeadRow);
    
    for (const option of options) {
        const tableRow = document.createElement('tr');
        let tableData = document.createElement('td');
        text = document.createTextNode(formatMeters(option.distance));
        tableData.appendChild(text);
        tableRow.appendChild(tableData);
        
        tableData = document.createElement('td');
        text = document.createTextNode(formatMeters(option.up));
        tableData.appendChild(text);
        tableRow.appendChild(tableData);

        tableData = document.createElement('td');
        text = document.createTextNode(formatMeters(option.down));
        tableData.appendChild(text);
        tableRow.appendChild(tableData);

        tableRow.junction = junctionId;
        tableRow.wanderabschnitt = option.wanderabschnitt;

        tableRow.addEventListener('click', function() {
            optionSelected(this);
        });
        tableRow.addEventListener('mouseover', function() {
            highlightOption(this, this.wanderabschnitt);
        });
        tableRow.addEventListener('mouseout', function() {
            normalizeOption(this, this.wanderabschnitt);
        });
        optionsTable.appendChild(tableRow);
    }
    const h3 = document.createElement('h3');
    text = document.createTextNode("Wähle eine Variante");
    h3.appendChild(text);
    routeOptions.appendChild(h3);
    routeOptions.appendChild(optionsTable);
}
function optionSelected(tableRow) {
    log.debug('option selected', tableRow.junction);
    optionsOverlay.setPosition(undefined);

    window.map.removeLayer(optAbschnittLayer);
    window.document.onJunctionSelected(tableRow.junction,
                                       tableRow.wanderabschnitt);
}
function highlightOption(tableRow, wanderabschnittId) {
    tableRow.style.backgroundColor = 'yellow';

    const vectorSource = new VectorSource({
        format: new GeoJSON(),
        url: './data/wanderabschnitt/' +  wanderabschnittId + '.geojson',
        projection: 'ESPG:3857'
    });
    const abschnittLayer = new VectorLayer({
        source: vectorSource,
        style: new Style({
            stroke: new Stroke({
                color: 'green',
                width: 4
            })
        })
    });
    optAbschnittLayer = abschnittLayer;
    window.map.addLayer(abschnittLayer);
}
function normalizeOption(tableRow, wanderabschnittId) {
    tableRow.style.backgroundColor = 'white';
    window.map.removeLayer(optAbschnittLayer);
}

function showRouteInfos(wanderabschnitte, selectedVerlauf) {
    const routeInfo = document.getElementById('routeInfo');
    routeInfo.innerHTML = "";
    
    let distance = 0;
    let up = 0;
    let down = 0;
    wanderabschnitte.forEach((verbindung => {
        distance += verbindung.distance;
        up += verbindung.up;
        down += verbindung.down;
    }));
    const headElement = document.createElement('h2');
    const headText = document.createTextNode('Deine Route');
    headElement.appendChild(headText);
    routeInfo.appendChild(headElement);

    let verlaufCodes = '';
    selectedVerlauf.forEach(junction => {
        if (verlaufCodes.length > 0) {
            verlaufCodes += ', ';
        }
        verlaufCodes += junction[1];
    });
    const infoTable = document.createElement('table');

    addTableRow(infoTable, 'Gesamtlänge', formatMeters(distance));
    addTableRow(infoTable, 'Anstieg', formatMeters(up));
    addTableRow(infoTable, 'Abstieg', formatMeters(down));
    routeInfo.appendChild(infoTable);
}
function formatMeters(nr) {
    return Number.parseFloat(nr).toFixed(0) + ' m';
}
function addTableRow(tableElement, nme, txt) {
    const tableRow = document.createElement('tr');
    let tableData = document.createElement('td');
    let text = document.createTextNode(nme);
    tableData.appendChild(text);
    tableRow.appendChild(tableData);

    tableData = document.createElement('td');
    text = document.createTextNode(txt);
    tableData.appendChild(text);
    tableRow.appendChild(tableData);
    tableElement.appendChild(tableRow);
}

const RouteBuilder = {};
RouteBuilder.getJunctionInfos = getJunctionInfos;
RouteBuilder.getWanderpunkte = getWanderpunkte;
RouteBuilder.showPossibilities = showPossibilities;
RouteBuilder.showRouteInfos = showRouteInfos;
RouteBuilder.postRoute = postRoute;
RouteBuilder.setOptionsOverlay = setOptionsOverlay;
export default RouteBuilder;
